import { Button } from '@sede-enterprise/shell-ds-react-framework';
import {
  ChartNoDataContainer,
  ErrorStateHeader,
  ErrorStateSubtext,
  NoDataWrapper,
} from 'components/ErrorStates/ChartErrorStates/ChartErrorStates.styled';
import { NoDataLighthouse } from 'components/ErrorStates/ErrorStateSvg/NoDataLighthouse';
import { useNavigate } from 'react-router';

const ChartNoDataScreen = () => {
  const navigate = useNavigate();
  return (
    <ChartNoDataContainer data-testid="chart-data-error-container">
      <NoDataWrapper>
        <NoDataLighthouse />
        <ErrorStateHeader>There's an issue on our end</ErrorStateHeader>
        <ErrorStateSubtext style={{ width: 400, textAlign: 'center' }}>
          We apologise for the inconvenience. Please try reloading the page, or
          restart your session by selecting a company.
        </ErrorStateSubtext>
      </NoDataWrapper>
      <div style={{ marginTop: 20 }}>
        <Button
          style={{ marginRight: 12 }}
          onClick={() => window.location.reload()}
          variant={'outlined'}
        >
          Reload this page
        </Button>
        <Button onClick={() => navigate('/')}>Select a company</Button>
      </div>
    </ChartNoDataContainer>
  );
};

export default ChartNoDataScreen;
